import React, { useEffect } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Page from '../../component/page'

const loadDiscs = () => ({
  type: 'LOAD_DISCS',
  payload: {
    request: {
      url: `/v3/disc`,
    },
  },
})

// Layout for the whole /discs section: renders the tab bar and the active sub-page via
// <Outlet />. The user's discs/bags load once when the section is first opened.
function Discs({ user, loading, loaded }) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (user && !loaded && !loading) {
      dispatch(loadDiscs())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loaded])

  return (
    <Page className="discs">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Discs {loading && <small>loading…</small>}</h1>

            <ul className="nav nav-tabs discs-tabs">
              <li className="nav-item">
                <NavLink end to="/discs" className="nav-link">
                  My Discs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/discs/bags" className="nav-link">
                  Bags
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/discs/brands" className="nav-link">
                  Brands
                </NavLink>
              </li>
            </ul>

            <div className="discs-tab-content">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  loading: state.discs.loading,
  loaded: state.discs.loaded,
})

export default connect(mapStateToProps)(Discs)
